import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import api from '../const/axios'
import RequireAuth from './RequireAuth'

type Role = 'organizer' | 'superadmin'

/**
 * Renders children only for signed-in users holding the given role; everyone else is sent
 * home before any of the page is shown. UI gate only — the API enforces the same rules.
 */
const RoleGate: React.FC<{ role: Role; children: React.ReactElement }> = ({ role, children }) => {
  const [allowed, setAllowed] = useState<boolean | null>(null)

  useEffect(() => {
    let cancelled = false
    api.get('/users/organizer/me')
      .then((res) => {
        const ok = role === 'superadmin' ? !!res.data?.isSuperAdmin : !!res.data?.isOrganizer || !!res.data?.isSuperAdmin
        if (!cancelled) setAllowed(ok)
      })
      .catch(() => { if (!cancelled) setAllowed(false) })
    return () => { cancelled = true }
  }, [role])

  if (allowed === null) return <div className="min-h-screen bg-gray-50 dark:bg-gray-950" />
  return allowed ? children : <Navigate to="/" replace />
}

// RequireAuth only mounts its child once signed in, so the role check never runs anonymously.
const RequireRole: React.FC<{ role: Role; children: React.ReactElement }> = ({ role, children }) => (
  <RequireAuth><RoleGate role={role}>{children}</RoleGate></RequireAuth>
)

export default RequireRole
